import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CompanyService } from "../../../../../../services/admon/company.service";
import { AuthenticationService } from "../../../../../../services/security/authentication.service";
import { Company } from "../../../../../../utils/types/admon/company.type";
import { RecordAction } from "../../../../../../utils/enums/shared/enums";
import { TranslateService } from "@ngx-translate/core";
import { ValidationService } from "../../../../../../services/validation/validation.service";
import { UserSessionType } from "../../../../../../utils/types/core/models/user-session.type";
import { ObservableDataService } from "../../../../../../services/core/observable-data.service";

@Component({
    selector: "wtf-company-form",
    templateUrl: "./company-form.component.html",
    styleUrls: ["./company-form.component.scss"],
    providers: [CompanyService, AuthenticationService, ValidationService],
    encapsulation: ViewEncapsulation.None,
})
export class CompanyFormComponent implements OnInit {
    companyModel: Company;
    dialogTitle: string;
    companyForm: FormGroup;
    action: RecordAction;
    callback: (company) => void;

    operators: any;
    showCompanies: boolean;
    currentUser: UserSessionType;
    parents: any;

    // presetColors = MatColors.presets;
    recordAction = RecordAction;

    constructor(
        public dialogRef: MatDialogRef<CompanyFormComponent>,
        private translateService: TranslateService,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private service: CompanyService,
        private validationService: ValidationService,
        private ods: ObservableDataService,
    ) {
        this.translateService.setDefaultLang("en");
        this.translateService.use(localStorage.getItem("language") || "en");
        this.companyModel = data.company;
        this.parents = data.parents;
        this.action = data.action;
        this.callback = data.callback;
        this.currentUser = this.ods.getLoggedUser();
        this.showCompanies = this.currentUser.companyIsSaaSOwner;
        console.log('showCompanies', this.showCompanies);

        if (
            this.action === RecordAction.Update ||
            this.action === RecordAction.View
        ) {
            this.dialogTitle = this.companyModel.name;
        } else {
            this.dialogTitle = "Nueva Compañía";
            this.dialogTitle = this.translateService.instant(this.dialogTitle);
            this.companyModel = new Company();
        }

        this.companyForm = this.createForm();
    }

    ngOnInit() { }

    isControlValid(form: FormGroup, field: string) {
        return this.validationService.isValidField(form, field);
    }

    getErrorMessage(form: FormGroup, field: string, text: string) {
        return this.validationService.getErrorMessage(form, field, text);
    }

    createForm() {
        const form = new FormGroup({
            name: new FormControl(this.companyModel.name, [
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(50),
                Validators.pattern(
                    "^[a-zA-ZñÑÀ-ú0-9_]+( [a-zA-ZñÑÀ-ú0-9_]+)*$"
                ),
            ]),
            isActive: new FormControl(Boolean(this.companyModel.isActive)),
            ruc: new FormControl(this.companyModel.ruc, [Validators.required]),
            email: new FormControl(this.companyModel.email, [
                Validators.required,
                Validators.email,
            ]),
            phoneNumber: new FormControl(this.companyModel.callCenterNumber, [
                Validators.pattern("^[0-9]+$"),
                Validators.required,
                Validators.maxLength(12),
                Validators.minLength(12),
            ]),
            address: new FormControl(this.companyModel.companyAddress, [
                Validators.required,
            ]),
            url: new FormControl(this.companyModel.url, [Validators.required]),
            company_parent_id: new FormControl(this.companyModel.company_parent_id),

        });

        form.controls["name"].valueChanges.subscribe(
            (value) => (this.companyModel.name = value)
        );
        form.controls["isActive"].valueChanges.subscribe(
            (value) => (this.companyModel.isActive = value)
        );
        form.controls["ruc"].valueChanges.subscribe(
            (value) => (this.companyModel.ruc = value)
        );
        form.controls["email"].valueChanges.subscribe(
            (value) => (this.companyModel.email = value)
        );
        form.controls["phoneNumber"].valueChanges.subscribe(
            (value) => (this.companyModel.callCenterNumber = value)
        );
        form.controls["address"].valueChanges.subscribe(
            (value) => (this.companyModel.companyAddress = value)
        );
        form.controls["url"].valueChanges.subscribe(
            (value) => (this.companyModel.url = value)
        );
        form.controls["company_parent_id"].valueChanges.subscribe(
            (value) => (this.companyModel.company_parent_id = value)
        );


        // form.controls['url_1'].valueChanges.subscribe((value) => this.companyModel.url = value);

        return form;
    }

    performAction() {
        if (this.companyForm.invalid) {
            return;
        }

        this.callback(this.companyModel);
    }
}
